module.exports = "/_next/static/images/NewCriticalLifeCoverLogo-791ccfcd8a4d2f82dccd498b8f7d4bd7.svg";